import { size } from '@styles/theme'

import { PiArrowsClockwiseBold } from 'react-icons/pi'


const PostRepostIcon = ({ isRepost }) => {
  if (isRepost) return (
    <div style={{ alignSelf: 'flex-end', height: size(3.5), paddingTop: size(0.25) }}>
      <PiArrowsClockwiseBold
        fill='grey'
        size={size(1.75)}
        style={{ transform: 'rotate(90deg)' }}
      />
    </div>
  )
}

export { PostRepostIcon }
